"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withForm = exports.useForm = void 0;
var react_1 = __importStar(require("react"));
var FormContext = react_1.default.createContext({
    disabledStates: {},
    errors: {},
    submitted: false,
    submitting: false,
    values: {},
    onError: function () { },
    onFieldDisabledChange: function () { },
    onFormChange: function () { }
});
exports.useForm = function () { return react_1.useContext(FormContext); };
var FormComponent = react_1.default.memo(function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (react_1.default.createElement("form", __assign({}, props, { "aria-label": "form" }), children));
});
/* eslint-disable react/no-unused-state */
var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form(props) {
        var _this = _super.call(this, props) || this;
        _this.handleError = function (name, error) {
            _this.setState(function (_a) {
                var _b;
                var errors = _a.errors;
                return ({
                    errors: __assign(__assign({}, errors), (_b = {}, _b[name] = error, _b))
                });
            });
        };
        _this.handleFormChange = function (name, value) {
            _this.setState(function (_a) {
                var _b;
                var values = _a.values;
                return ({
                    values: __assign(__assign({}, values), (_b = {}, _b[name] = value, _b))
                });
            });
        };
        _this.handleFieldDisabledChange = function (name, value) {
            _this.setState(function (_a) {
                var _b;
                var disabledStates = _a.disabledStates;
                return ({
                    disabledStates: __assign(__assign({}, disabledStates), (_b = {}, _b[name] = value, _b))
                });
            });
        };
        _this.handleSubmit = function (event) {
            event.preventDefault();
            _this.submit();
        };
        _this.handleDoneSubmitting = function () {
            if (_this.componentIsMounted) {
                _this.setState({ submitting: false });
            }
        };
        _this.componentIsMounted = false;
        _this.state = {
            disabledStates: {},
            errors: {},
            submitted: false,
            submitting: false,
            values: props.initialValues || {},
            onError: _this.handleError,
            onFieldDisabledChange: _this.handleFieldDisabledChange,
            onFormChange: _this.handleFormChange
        };
        return _this;
    }
    Form.prototype.componentDidMount = function () {
        this.componentIsMounted = true;
    };
    Form.prototype.componentWillUnmount = function () {
        this.componentIsMounted = false;
    };
    Form.prototype.submit = function () {
        var onSubmit = this.props.onSubmit;
        var _a = this.state, disabledStates = _a.disabledStates, errors = _a.errors, values = _a.values;
        this.setState({ submitted: true });
        if (Object.keys(errors).every(function (name) { return !errors[name]; })) {
            this.setState({ submitting: true });
            var submitValues_1 = {};
            Object.keys(values).forEach(function (name) {
                if (!disabledStates[name]) {
                    submitValues_1[name] = values[name];
                }
            });
            var submitted = onSubmit(submitValues_1);
            if (submitted && submitted.then) {
                submitted.then(this.handleDoneSubmitting).catch(this.handleDoneSubmitting);
            }
            else {
                this.setState({ submitting: false });
            }
        }
    };
    Form.prototype.render = function () {
        var _a = this.props, children = _a.children, initialValues = _a.initialValues, onSubmit = _a.onSubmit, props = __rest(_a, ["children", "initialValues", "onSubmit"]);
        return (react_1.default.createElement(FormContext.Provider, { value: this.state },
            react_1.default.createElement(FormComponent, __assign({}, props, { onSubmit: this.handleSubmit }), children)));
    };
    return Form;
}(react_1.default.Component));
exports.withForm = function (Child) {
    var Parent = function (props) { return (react_1.default.createElement(FormContext.Consumer, null, function (state) { return react_1.default.createElement(Child, __assign({}, state, props)); })); };
    var childName = Child.displayName || Child.name || "Component";
    Parent.displayName = "withForm(" + childName + ")";
    return Parent;
};
exports.default = Form;
